import ApiProduct from './modules/Product';
import ApiUsers from './modules/Users';
import ApiOrders from './modules/Orders';
import ApiPayments from './modules/Payments';
import ApiOrder from './modules/Order';
import ApiClients from './modules/Clients';
import ApiUser from './modules/User'
import ApiProfile from './modules/Profile';
import Tags from './modules/Tags';
import Tag from './modules/Tag';
import Logs from './modules/Logs';
import Services from './modules/Services';
import Banners from './modules/Banners';
import Banner from './modules/Banner';
import Products from './modules/Products';

const Api = {
    products: new Products(),
    product: new ApiProduct(),
    users: new ApiUsers(),
    orders: new ApiOrders(),
    payments: new ApiPayments(),
    order: new ApiOrder(),
    clients: new ApiClients(),
    user: new ApiUser(),
    profile: new ApiProfile(),
    tags: new Tags(),
    tag: new Tag(),
    logs: new Logs(),
    services: new Services(),
    banners: new Banners(),
    banner: new Banner()
}

export default Api;
